import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Professional confirm dialog — never use window.confirm / alert.
 */
export default function ConfirmModal({
  show,
  title,
  body,
  confirmLabel,
  cancelLabel,
  variant = 'primary',
  loading = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  const resolvedConfirm = confirmLabel || t('common.confirm');
  const resolvedCancel = cancelLabel || t('common.cancel');

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : onCancel}
      centered
      backdrop="static"
      className="confirm-modal"
      dialogClassName="confirm-modal-dialog"
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title className="fs-5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {typeof body === 'string' ? <p className="mb-0 text-body-secondary">{body}</p> : body}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 confirm-modal-footer">
        <Button variant="outline-secondary" disabled={loading} onClick={onCancel}>
          {resolvedCancel}
        </Button>
        <Button variant={variant} disabled={loading} onClick={onConfirm}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" /> {t('common.working')}
            </>
          ) : (
            resolvedConfirm
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
